<template>
    <div id="app">
        <!-- loading -->
        <app-loading></app-loading>
        <div id="router-view" v-if="alive" >
            <!-- routes -->
            <router-view @destroyComponent="rebootComponent($event)"></router-view>
        </div>
    </div>
</template>

<script>
    import Vue from "vue"
    import store from "./vuex/store"
    import shortid from "shortid"
    import { mapState, mapMutations, mapActions } from "vuex"

    import LoadingComponent from "./components/Utilities/Loading.vue"
    import { version } from "../package.json"

    export default {
        store,
        components: {
            "app-loading": LoadingComponent
        },
        data(){
            return {
                stateDBQueue: null,
                alive: true
            }
        },
        computed: {
            ...mapState(["app", "dimensions"])
        },
        methods: {
            ...mapMutations(["SET_WINDOW_DIMENSIONS"]),
            setWindowDimensions() {
                this.SET_WINDOW_DIMENSIONS({
                    width: document.documentElement.clientWidth,
                    height: document.documentElement.clientHeight
                });
            },
            rebootComponent(alive) {
                this.alive = alive
                this.VXORM.PaymentMethod.deleteAll()
                this.VXORM.PromotionChannel.deleteAll()
                this.VXORM.Product.deleteAll()
                this.VXORM.Service.deleteAll()
                this.VXORM.PhoneLine.deleteAll()
                this.VXORM.User.deleteAll()
                this.VXORM.Device.deleteAll()
                this.VXORM.Company.deleteAll()
                this.VXORM.CompanyUser.deleteAll()
                this.VXORM.CompanyUserResource.deleteAll()
                this.VXORM.CompanySetting.deleteAll()
                this.VXORM.Resource.deleteAll()
                this.VXORM.STATE_Request.deleteAll()
                this.VXORM.Request.deleteAll()
                this.VXORM.RequestOrder.deleteAll()
                this.VXORM.RequestOrderProduct.deleteAll()
                this.VXORM.RequestOrderService.deleteAll()
                this.VXORM.RequestOrderPayment.deleteAll()
                this.VXORM.RequestContact.deleteAll()
                this.VXORM.Contact.deleteAll()
                this.VXORM.ContactAddress.deleteAll()
                this.VXORM.Address.deleteAll()

                setTimeout(() => {
                    this.alive = !alive
                }, 0)
            }
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener("resize", this.setWindowDimensions);
                this.setWindowDimensions();
            });
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.setWindowDimensions);
        }
    };
</script>

<style lang="scss">
</style>
